import BottomQuickSetupBar from './BottomQuickSetupBar';

export default BottomQuickSetupBar;
